/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactGroupLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2a5 5 0 1 0 0 10A5 5 0 0 0 9 2zM6 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM4 21c0-1.499.388-2.732 1.14-3.58C5.874 16.595 7.076 16 9 16c1.608 0 2.711.415 3.459 1.034l1.01-1.749C12.331 14.452 10.835 14 9 14c-2.361 0-4.16.748-5.355 2.092C2.47 17.416 2 19.183 2 21v1h2zM15.781 5.258a3 3 0 1 1-.637 5.1 7.027 7.027 0 0 1-1.201 1.599A5 5 0 1 0 15.01 3.41c.34.568.602 1.189.77 1.847zM19.5 16c.887 0 1.333.587 1.333 1v1h-2.666v-1c0-.413.446-1 1.333-1zm3.333 2v-1c0-1.796-1.642-3-3.333-3s-3.333 1.204-3.333 3v1H15v6h9v-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactGroupLock as ContactGroupLock };
